import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator(
  'benefits_sets_av_calculator_enqueue',
  '/benefits_sets_av_calculator_enqueue',
  'enqueue'
)
const actions = generator.generate()

export default actions
